/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Campaignservicev1JobStatus } from '../models/Campaignservicev1JobStatus';
import { Campaignservicev1OrderLine } from '../models/Campaignservicev1OrderLine';
import { OrderLineJobErrorDetail } from '../models/OrderLineJobErrorDetail';
import { V1JobTemplate } from '../models/V1JobTemplate';
import { HttpFile } from '../http/http';

export class V1OrderLineJob {
    'jobId'?: string;
    'status'?: Campaignservicev1JobStatus;
    'template'?: V1JobTemplate;
    'orderLines'?: Array<Campaignservicev1OrderLine>;
    'errors'?: Array<string>;
    'filename'?: string;
    'orgId'?: string;
    'errorDetails'?: Array<OrderLineJobErrorDetail>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "jobId",
            "baseName": "job_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "Campaignservicev1JobStatus",
            "format": ""
        },
        {
            "name": "template",
            "baseName": "template",
            "type": "V1JobTemplate",
            "format": ""
        },
        {
            "name": "orderLines",
            "baseName": "order_lines",
            "type": "Array<Campaignservicev1OrderLine>",
            "format": ""
        },
        {
            "name": "errors",
            "baseName": "errors",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "filename",
            "baseName": "filename",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "errorDetails",
            "baseName": "error_details",
            "type": "Array<OrderLineJobErrorDetail>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1OrderLineJob.attributeTypeMap;
    }

    public constructor() {
    }
}

